import { TimeSpanDto } from './../../helpers/models/timeSpanDto';
import * as moment from 'moment';
import * as _ from 'lodash';

export function dateConvert(objectVal: any): Date {
    const curr = new Date();
    const result = new Date(
        Number(objectVal.year),
        Number(objectVal.month) - 1, // because month is zero-indexed, Jan === 0, Feb === 1, Mar === 2 and so on
        Number(objectVal.day),
        objectVal.hours !== undefined ? Number(objectVal.hours) : curr.getHours(),
        objectVal.minutes !== undefined ? Number(objectVal.minutes) : curr.getMinutes(),
        objectVal.seconds !== undefined ? Number(objectVal.seconds) : curr.getSeconds(),
    );
    return result;
}

export const isDateValid = function (date: Date): boolean {
    const d = moment(date);
    return d.isValid();
};

export function sortStringArray(arr: any): string[] {
    return arr.sort((n1, n2) => {
        if (n1 > n2) {
            return 1;
        }

        if (n1 < n2) {
            return -1;
        }
        return 0;
    });
}

export function sortNumArrayAsc(arr: any): number[] {
    return arr.sort((n1, n2) => n1 - n2);
}

export function sortNumArrayDesc(arr: any): number[] {
    return arr.sort((n1, n2) => n2 - n1);
}

export function sortArray(arr: any, values: string[]): any {
    return _.sortBy(arr, values);
}

export function distinctArray(arr: any): any {
    return arr.filter((n, i) => arr.indexOf(n) === i);
}

export function intersactArray(arrA: any, arrB: any): any {
    return arrA.filter((x) => arrB.includes(x));
}

export function intersactObjectArray(arrA: any, arrB: any, value: string): any {
    return arrA.filter((x) => arrB.includes(x['value']));
}

export function differenceArray(arrA: any, arrB: any): any {
    return arrA.filter((x) => !arrB.includes(x));
}

export function unionArray(arrA: any, arrB: any): any {
    return [...new Set([...arrA, ...arrB])];
}

export function groupArray(arr: any, groupByField: any): any {
    return arr.filter((thing, i, arr) => arr.findIndex((t) => t['groupByField'] === thing['groupByField']) === i);
}

export function groupByDateArray(arr: any, dateField: any): any {
    return arr.filter(
        (thing, i, arr) =>
            arr.findIndex((t) => t['dateField'] != null && moment(t['dateField']).format('L') === moment(thing['dateField']).format('L')) === i,
    );
}

export function FirstUpperCase(inputString: string): string {
    return inputString.replace(inputString[0], inputString[0].toUpperCase());
}

export function calculateTotalRows(note: string): number {
    let totalRows = 0;
    if (note) {
        const noteRows = note.split('\n');
        totalRows = noteRows.length > 2 ? noteRows.length : 2; //min 2 rows
        noteRows.forEach((value) => {
            if (value.length > 50) {
                totalRows += 1; // add a row for long sentences
            }
        });
    }
    return totalRows;
}

export function convertToTime(timeSpanObj: TimeSpanDto): string {
    if (timeSpanObj == null || timeSpanObj.hours == null || timeSpanObj.minutes == null) {
        return '';
    }

    // fetch time values
    const hours = Number(timeSpanObj.hours);
    const minutes = Number(timeSpanObj.minutes);
    // const seconds = Number(timeSpanObj.seconds);

    // calculate
    let timeValue;

    if (hours > 0 && hours <= 12) {
        timeValue = '' + hours;
    } else if (hours > 12) {
        timeValue = '' + (hours - 12);
    } else if (hours == 0) {
        timeValue = '12';
    }

    timeValue += minutes < 10 ? ':0' + minutes : ':' + minutes; // get minutes
    // timeValue += seconds < 10 ? ':0' + seconds : ':' + seconds; // get seconds
    timeValue += hours >= 12 ? ' PM' : ' AM'; // get AM/PM

    return timeValue;
}

export function convertFromTimeSpan(timeSpanObj: TimeSpanDto): string {
    if (timeSpanObj == null || timeSpanObj.hours == null || timeSpanObj.minutes == null) {
        return '';
    }

    const hours = `0${timeSpanObj.hours}`.slice(-2);
    const minutes = `0${timeSpanObj.minutes}`.slice(-2);
    const seconds = `0${timeSpanObj.seconds}`.slice(-2);

    return `${hours}:${minutes}:${seconds}`;
    // convertion using ticks
    // const numTicks: number = +timeSpanObj.ticks;
    // const hours = Math.round((numTicks / (60 * 60 * 10000000)) % 24);
    // const mins = Math.round((numTicks / (60 * 10000000)) % 60);
}

export function convertToTimeSpan(hours, minutes, seconds): TimeSpanDto {
    return {
        days: null,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        milliseconds: null,
        ticks: null,
        totalDays: null,
        totalHours: null,
        totalMilliseconds: null,
        totalMinutes: null,
        totalSeconds: null,
    };
}

export function timeDiff(start, end) {
    start = start.split(':');
    end = end.split(':');
    const startDate = new Date(0, 0, 0, start[0], start[1], 0);
    const endDate = new Date(0, 0, 0, end[0], end[1], 0);
    let diff = endDate.getTime() - startDate.getTime();
    let hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    const minutes = Math.floor(diff / 1000 / 60);
    if (hours < 0) {
        hours = hours + 24;
    }
    return (hours <= 9 ? '0' : '') + hours + ':' + (minutes <= 9 ? '0' : '') + minutes;
}

export function dateFilter(d: Date): boolean {
    const day = d.getDay();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6;
}
